  <form>
  <mat-form-field class="example-chip-list">
    <mat-label>{{label}}</mat-label>
    <mat-chip-grid #chipGrid aria-label="item selection">
      <mat-chip-row *ngFor="let item of selectedItems" (removed)="remove(item)">
        {{item.label}}
        <button matChipRemove [attr.aria-label]="'remove ' + item.label">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    </mat-chip-grid>
    <input [placeholder]="placeholder" #itemInput [formControl]="itemCtrl"
      [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"/>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let item of filteredItems | async" [value]="item">
        {{item.label}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
